import { Message } from 'element-ui';
import { ElMessageOptions, ElMessageComponent } from 'element-ui/types/message';
import { TranslateResult } from 'vue-i18n';

class AppMessage {
  private options: ElMessageOptions = {
    message: '',
    showClose: true,
    type: 'success',
    duration: 5000,
  };
  private message?: ElMessageComponent;

  public show(message?: string | TranslateResult, type: 'success'|'info'|'error'|'warning' = 'success') {
    const options = Object.assign({}, this.options,  {
      message, type,
    });
    this.message = Message(options);
  }

  public hide() {
    if (this.message) {
      this.message.close();
    }
  }
}

export default new AppMessage();
